import { Building2, Users } from "lucide-react";

const label = (k) => (k === "__emp" ? "رواتب الموظفين" : k);

export const CompanyTabs = ({ comps, comp, setComp }) => {
  if (!comps.length) return null;
  return (
    <div className="flex gap-2 overflow-x-auto pb-1" data-testid="salaries-company-tabs">
      {comps.map((c) => {
        const on = c.key === comp;
        const Icon = c.key === "__emp" ? Users : Building2;
        return (
          <button key={c.key} type="button" onClick={() => setComp(c.key)} data-testid={`salaries-company-${c.key}`}
            className={`flex shrink-0 items-center gap-2 rounded-xl border px-4 py-2.5 text-sm font-bold transition-colors ${on ? "border-indigo-600 bg-indigo-600 text-white shadow-sm" : "border-slate-200 bg-white text-slate-600 hover:border-indigo-300"}`}>
            <Icon className="h-4 w-4" /> {label(c.key)}
            <span className={`rounded-full px-2 py-0.5 text-[11px] ${on ? "bg-white/20" : "bg-slate-100 text-slate-500"}`}>{c.count}</span>
          </button>
        );
      })}
    </div>
  );
};
